import {requirement} from 'constants/url';
import {AddWith2ParamsOptions} from '../../../../components/grid-dx/types';
import {useAddWith2ParamsOptions} from './index';

function useAddProfilesWithValideCourse() {
  const addCollaboratorInAttended = useAddWith2ParamsOptions(
    requirement,
    'edit',
  );
  return (addWith2ParamsOptions: AddWith2ParamsOptions) =>
    addCollaboratorInAttended(addWith2ParamsOptions);
}

export default useAddProfilesWithValideCourse;
